/** Thai strings for the real-money shop (shared/shop.ts, ui/premiumShop.ts, networking/shop.ts) and its items. */
export const SHOP: Record<string, string> = {
  /* ---- Ready-made heroes (shared/looks.ts) ---- */
  'Ready-made Heroes': 'ตัวละครสำเร็จ',
  'Finished characters to wear instead of your drawing. Looks only: your class, skill and stats stay the same.': 'ตัวละครที่วาดเสร็จพร้อมใช้ ใส่แทนรูปที่วาดเองได้เลย เปลี่ยนแค่หน้าตา อาชีพ สกิล และค่าพลังยังเหมือนเดิม',
  'Buy with real money': 'ซื้อด้วยเงินจริง',
  WEARING: 'กำลังใส่',
  'Use my drawing': 'ใช้รูปที่วาดเอง',
  'Wear it': 'ใส่เลย',
  '{hero} becomes {name}': '{hero} จะกลายเป็น {name}',
  'Star Idol': 'ไอดอลดาวเด่น',
  'Sings, dances and wins.': 'ร้อง เต้น แล้วก็ชนะ',
  'Dino Hoodie Kid': 'หนูน้อยฮู้ดไดโน',
  'Rawr! Means "I win" in dinosaur.': 'แฮ่! แปลว่า "ฉันชนะ" ในภาษาไดโนเสาร์',
  'Kitty Witch': 'แม่มดน้อยหูแมว',
  'Brews spells with milk and glitter.': 'ปรุงคาถาด้วยนมกับกากเพชร',
  'Robo Buddy': 'หุ่นยนต์เพื่อนซี้',
  'Built from a box. Powered by snacks.': 'สร้างจากกล่องกระดาษ ใช้ขนมเป็นพลังงาน',
  'Paper Samurai': 'ซามูไรกระดาษ',
  'Folded armour, sharp moves.': 'เกราะพับกระดาษ ท่าคมกริบ',
  'Bunny Princess': 'เจ้าหญิงกระต่าย',
  'Royal, fluffy and very fast.': 'สูงศักดิ์ ฟูฟ่อง และเร็วมาก',
  'Space Ranger': 'นักบินอวกาศจิ๋ว',
  'To the last page and beyond!': 'สู่หน้าสุดท้ายและไกลกว่านั้น!',
  'Boba Knight': 'อัศวินชานมไข่มุก',
  'Armoured in tea. Lance of straw.': 'เกราะชานม หอกหลอดดูด',
  // Products
  'Pastel Pen Pack': 'ชุดปากกาพาสเทล',
  'Four soft pastel inks: pink, blue, mint and lemon.': 'หมึกพาสเทลนุ่มๆ 4 สี: ชมพู ฟ้า มิ้นต์ และเหลืองเลมอน',
  'Neon Pen Pack': 'ชุดปากกานีออน',
  'Four glowing neon inks that pop off the page.': 'หมึกนีออนเรืองแสง 4 สี เด่นสุดๆ บนหน้ากระดาษ',
  'Galaxy Pen Pack': 'ชุดปากกากาแล็กซี',
  'Four cosmic inks for stars, planets and space monsters.': 'หมึกอวกาศ 4 สี สำหรับดวงดาว ดาวเคราะห์ และมอนสเตอร์อวกาศ',
  'Royal Win Stamp': 'ตราประทับชนะแบบราชา',
  'A golden ROYAL WIN on every victory.': 'ประทับ ROYAL WIN สีทองทุกครั้งที่ชนะ',
  'Dragon Slayer Stamp': 'ตราประทับนักล่ามังกร',
  'A green DRAGON SLAYER on every victory.': 'ประทับ DRAGON SLAYER สีเขียวทุกครั้งที่ชนะ',
  'Lightning Stamp': 'ตราประทับสายฟ้า',
  'A crackling LIGHTNING on every victory.': 'ประทับ LIGHTNING เปรี้ยงๆ ทุกครั้งที่ชนะ',
  'Bronze Supporter': 'ผู้สนับสนุนระดับทองแดง',
  'Thank you! A bronze supporter badge and the Thank You stamp.': 'ขอบคุณมาก! ได้ป้ายผู้สนับสนุนทองแดงและตราประทับ Thank You',
  'Silver Supporter': 'ผู้สนับสนุนระดับเงิน',
  'A silver badge, the Thank You stamp and the Supporter Star stamp.': 'ได้ป้ายสีเงิน ตราประทับ Thank You และตราประทับ Supporter Star',
  'Gold Supporter': 'ผู้สนับสนุนระดับทอง',
  'A gold badge, both supporter stamps and the Supporter Gold pen.': 'ได้ป้ายสีทอง ตราประทับผู้สนับสนุนทั้งสองแบบ และปากกาทองผู้สนับสนุน',
  'Diamond Supporter': 'ผู้สนับสนุนระดับเพชร',
  'The diamond badge and every supporter reward. You make this game possible!': 'ได้ป้ายเพชรและของขวัญผู้สนับสนุนทุกชิ้น เกมนี้อยู่ได้เพราะคุณ!',
  // Premium cosmetics
  'Pastel Pink Pen': 'ปากกาชมพูพาสเทล',
  'Soft pastel pink ink.': 'หมึกชมพูพาสเทลนุ่มๆ',
  'Pastel Blue Pen': 'ปากกาฟ้าพาสเทล',
  'Soft pastel blue ink.': 'หมึกฟ้าพาสเทลนุ่มๆ',
  'Pastel Mint Pen': 'ปากกามิ้นต์พาสเทล',
  'Soft pastel mint ink.': 'หมึกมิ้นต์พาสเทลนุ่มๆ',
  'Pastel Lemon Pen': 'ปากกาเลมอนพาสเทล',
  'Soft pastel lemon ink.': 'หมึกเหลืองเลมอนพาสเทลนุ่มๆ',
  'Neon Pink Pen': 'ปากกาชมพูนีออน',
  'Glowing neon pink ink.': 'หมึกชมพูนีออนเรืองแสง',
  'Neon Orange Pen': 'ปากกาส้มนีออน',
  'Glowing neon orange ink.': 'หมึกส้มนีออนเรืองแสง',
  'Neon Green Pen': 'ปากกาเขียวนีออน',
  'Glowing neon green ink.': 'หมึกเขียวนีออนเรืองแสง',
  'Electric Blue Pen': 'ปากกาฟ้าไฟฟ้า',
  'Glowing electric blue ink.': 'หมึกฟ้าไฟฟ้าเรืองแสง',
  'Galaxy Purple Pen': 'ปากกาม่วงกาแล็กซี',
  'Deep cosmic purple ink.': 'หมึกม่วงเข้มแบบอวกาศ',
  'Starlight Pen': 'ปากกาแสงดาว',
  'Pale starlight ink.': 'หมึกสีแสงดาวอ่อนๆ',
  'Nebula Pink Pen': 'ปากกาชมพูเนบิวลา',
  'Swirling nebula pink ink.': 'หมึกชมพูเนบิวลาหมุนวน',
  'Deep Space Pen': 'ปากกาห้วงอวกาศ',
  'Darkest night-sky blue ink.': 'หมึกน้ำเงินฟ้ายามค่ำมืดที่สุด',
  'Supporter Gold Pen': 'ปากกาทองผู้สนับสนุน',
  'A thank-you gold ink for Gold supporters.': 'หมึกสีทองขอบคุณสำหรับผู้สนับสนุนระดับทอง',
  'ROYAL WIN!': 'ชนะแบบราชา!',
  'DRAGON SLAYER': 'นักล่ามังกร',
  '⚡ LIGHTNING ⚡': '⚡ สายฟ้า ⚡',
  'Thank You Stamp': 'ตราประทับขอบคุณ',
  'For everyone who supports Paper Legends.': 'สำหรับทุกคนที่สนับสนุน Paper Legends',
  'THANK YOU!': 'ขอบคุณ!',
  'Supporter Star Stamp': 'ตราประทับดาวผู้สนับสนุน',
  'A shining star for Silver supporters and up.': 'ดาวเปล่งประกายสำหรับผู้สนับสนุนระดับเงินขึ้นไป',
  '★ SUPPORTER ★': '★ ผู้สนับสนุน ★',
  'Diamond Stamp': 'ตราประทับเพชร',
  'The rarest stamp, for Diamond supporters.': 'ตราประทับที่หายากที่สุด สำหรับผู้สนับสนุนระดับเพชร',
  '◆ DIAMOND ◆': '◆ เพชร ◆',
  // Special Shelf
  'Loading the special shelf…': 'กำลังโหลดชั้นพิเศษ…',
  'Special Shelf': 'ชั้นพิเศษ',
  'Paid with real money through Stripe (cards or PromptPay). Looks only — never battle power.': 'จ่ายด้วยเงินจริงผ่าน Stripe (บัตรหรือพร้อมเพย์) เป็นของแต่งเท่านั้น ไม่เพิ่มพลังต่อสู้',
  'Coming soon: the special shelf opens when payments are set up.': 'เร็วๆ นี้: ชั้นพิเศษจะเปิดเมื่อตั้งค่าระบบชำระเงินเสร็จ',
  'You are a {tier}. Thank you!': 'คุณคือ{tier} ขอบคุณมาก!',
  'Pen Packs': 'ชุดปากกา',
  'Special Stamps': 'ตราประทับพิเศษ',
  'Support the Developer': 'สนับสนุนผู้พัฒนา',
  'Like the game? Supporting helps keep it free for everyone, and you get a badge and thank-you rewards.': 'ชอบเกมนี้ไหม? การสนับสนุนช่วยให้เกมเล่นฟรีต่อไปได้ และคุณจะได้ป้ายกับของขวัญขอบคุณ',
  OWNED: 'มีแล้ว',
  'The special shelf needs the game server.': 'ชั้นพิเศษต้องต่อเซิร์ฟเวอร์เกม',
  'Buying with real money needs a grown-up.': 'การซื้อด้วยเงินจริงต้องให้ผู้ใหญ่ช่วย',
  'Keep your purchases safe': 'เก็บของที่ซื้อให้ปลอดภัย',
  'You are playing as a guest. Link Google in Settings → Account so you never lose what you buy. Continue anyway?': 'ตอนนี้คุณเล่นแบบ Guest ผูก Google ที่ ตั้งค่า → บัญชี ไว้ ของที่ซื้อจะได้ไม่หาย จะซื้อต่อเลยไหม?',
  'Could not open the payment page': 'เปิดหน้าชำระเงินไม่ได้',
  // Coming back from Stripe
  'Payment cancelled. Nothing was charged.': 'ยกเลิกการชำระเงินแล้ว ไม่มีการตัดเงิน',
  'Checking your payment…': 'กำลังตรวจการชำระเงิน…',
  'Thank you! Your items are in the Stationery Shop.': 'ขอบคุณมาก! ของอยู่ในร้านเครื่องเขียนแล้ว',
  'The payment did not go through. Nothing was charged.': 'การชำระเงินไม่สำเร็จ ไม่มีการตัดเงิน',
  'Your payment is still being confirmed. Your items will appear as soon as it is done.': 'การชำระเงินยังรอการยืนยัน ของจะเข้ามาทันทีที่เสร็จ',
};
